import ReactDOM from "react-dom/client";
import "./index.css";
import { AuthProvider } from "./Context/AuthProvider";
import { RouterProvider } from "react-router-dom";
import routes from "./routes.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <AuthProvider>
    <RouterProvider router={routes} />
  </AuthProvider>
);
